import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";
import {
  DETAILED_MOVEMENTS_TABLE_COLUMNS,
  getDetailedMovementsTableColumns,
} from "../arrobaBalanceUtil";

const ArrobaBalanceMovementsTable = ({ classes, movementBalances }) => {
  const { t } = useTranslations();

  const tableColumns = getDetailedMovementsTableColumns(t);

  if (!movementBalances.length) return null;

  return (
    <Grid>
      <Typography className={classes.title}>
        {t("animalCategory:detailed-movements-by-category")}
      </Typography>
      <Paper className={classes.tableContainer}>
        <Table id="movements-table" className={classes.table}>
          <TableHead
            data-testid="movements-table-header"
            className={classes.tableHeader}
          >
            <TableRow>
              {tableColumns.map((column) => (
                <TableHeaderCell
                  key={column.id}
                  classes={classes}
                  columnId={column.id}
                  label={column.label}
                />
              ))}
            </TableRow>
          </TableHead>
          <TableBody data-testid="movements-table-body">
            {movementBalances.map((item) => (
              <TableRow key={item.IdCategoriaAnimal}>
                <TableCell className={classes.tableRowCell}>
                  {item.CategoriaAnimal}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {t("common:measure.x-heads", { value: item.Entradas })}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {t("common:measure.x-kg", { value: item.PesoEntradas })}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {t("common:measure.x-heads", { value: item.Saidas })}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {t("common:measure.x-kg", { value: item.PesoSaidas })}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {t("common:measure.x-heads", { value: item.Nascimentos })}
                </TableCell>
                <TableCell className={classes.tableRowCell}>
                  {t("common:measure.x-heads", { value: item.Mortes })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Grid>
  );
};

const TableHeaderCell = ({ classes, columnId, label }) => {
  const cellClassesMap = {
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.CATEGORY]: classes.headerFirstCell,
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.ENTRIES]: classes.headerCell,
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.ENTRIES_WEIGHT]: classes.headerCell,
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.EXITS]: classes.headerCell,
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.EXITS_WEIGHT]: classes.headerCell,
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.BIRTHS]: classes.headerCell,
    [DETAILED_MOVEMENTS_TABLE_COLUMNS.DEATHS]: classes.headerLastCell,
  };

  const cellClass = cellClassesMap[columnId];

  return <TableCell className={cellClass}>{label}</TableCell>;
};

const styles = (theme) => {
  const defaultHeaderCell = {
    color: theme.palette.primary.main,
    padding: "4px 4px",
    fontSize: "14px",
    fontWeight: "500",
    letterSpacing: "1px",
    textAlign: "center",
    textTransform: "uppercase",
  };

  return {
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      fontStyle: "medium",
      fontStretch: "medium",
      lineHeight: "medium",
      letterSpacing: "medium",
      color: "#333333",
      marginTop: "40px",
      marginBottom: "20px",
    },
    tableContainer: {
      borderRadius: "16px",
    },
    table: {
      width: "100%",
      fontFamily: "Roboto",
      textAlign: "center",
      borderRadius: "2px",
      padding: "4px 24px 4px 24px",
      fontSize: "14px",
    },
    tableHeader: {
      marginTop: "25px",
      marginBottom: "25px",
      padding: "4px 24px 4px 24px",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      backgroundColor: "#e1e1e1",
    },
    headerFirstCell: {
      ...defaultHeaderCell,
      borderRadius: "16px 0 0 0 ",
    },
    headerCell: {
      ...defaultHeaderCell,
    },
    headerLastCell: {
      ...defaultHeaderCell,
      borderRadius: "0 16px 0 0",
    },
    tableRowCell: {
      color: "#666",
      padding: "4px 24px 4px 24px",
      textAlign: "center",
      fontSize: "14px",
      letterSpacing: "1px",
    },
  };
};

export default withStyles(styles)(ArrobaBalanceMovementsTable);
